export const inspStatus = [
  {
    value: 0,
    label: '未处理'
  },
  {
    value: 1,
    label: '已处理'
  },
  {
    value: 2,
    label: '处理中'
  },
  {
    value: 3,
    label: '正常'
  }
]
